export enum ACCORDION_ROLE {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
